"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
const lodash_1 = require("lodash");
const lodash_2 = require("lodash");
const React = __importStar(require("react"));
const country_select_1 = __importDefault(require("./country-select"));
const date_picker_1 = __importDefault(require("./date-picker"));
const state_field_1 = __importDefault(require("./state-field"));
require("./phone-number.scss");
require("./form-element.scss");
// TODO: Replace "any" with an actual type
class FormFieldElement extends React.Component {
    constructor(props) {
        super(props);
        this.state = { validDate: true };
    }
    dateValidChange = (valid) => {
        this.setState({ validDate: valid });
    };
    renderField() {
        const { input, type, fieldGroupClass, id, className, placeholder, options, isInline, label, dateProps, resetAgeMessage, country, maxLength, change, disabled, } = this.props;
        let field;
        if (type === 'email' || type === 'password' || type === 'text') {
            const shouldAutoFocus = fieldGroupClass && fieldGroupClass.includes('autoFocus');
            field = (React.createElement("input", { ...input, autoFocus: shouldAutoFocus ? true : false, id: id, className: 'Input ' + (className || ''), type: type, name: input.name, placeholder: placeholder, disabled: disabled, onChange: (event) => {
                    if (maxLength) {
                        if (event.target.value.length <= maxLength) {
                            input.onChange(event.target.value);
                        }
                    }
                    else {
                        input.onChange(event.target.value);
                    }
                } }));
        }
        // radios have multiple choices being mapped to the same field. if type is radio
        // create a map of the options, then pass them to the field param for display
        if (type === 'radio') {
            const radios = (0, lodash_2.map)(options, (option) => (React.createElement(teamsnap_ui_1.Radio, { ...input, key: option.value, name: option.value, label: option.text, group: input.name, isInline: isInline, inputProps: {
                    value: option.value,
                    checked: input.value === option.value,
                    onChange: (_e) => {
                        input.onChange(option.value);
                    },
                } })));
            field = radios;
        }
        if (type === 'checkbox') {
            field = (React.createElement(teamsnap_ui_1.Checkbox
            // id={id} // Updated version of Checkbox doesn't require id attr
            , { 
                // id={id} // Updated version of Checkbox doesn't require id attr
                name: input.name, 
                // type={type} // Updated version of Checkbox doesn't require id attr
                inputProps: { ...input }, label: label, mods: 'u-padBottomNone' }));
        }
        if (type === 'date') {
            field = (React.createElement(date_picker_1.default, { ...input, id: id, name: input.name, dateProps: { ...dateProps }, className: 'Input ' + (className || ''), change: change, onChange: (event, _value) => {
                    input.onChange(event.target.value);
                    if (resetAgeMessage) {
                        resetAgeMessage();
                    }
                }, onValidChange: this.dateValidChange }));
        }
        if (type === 'select') {
            field = (React.createElement("div", { className: "SelectBox" },
                React.createElement("select", { ...input, id: id, className: 'SelectBox-options ' + (className || ''), name: input.name }, (0, lodash_2.map)(options, (o) => (React.createElement("option", { key: o.value, value: o.value }, o.text))))));
        }
        if (type === 'phone') {
            field = (React.createElement("input", { ...input, className: 'Input ' + (className || ''), type: "text", name: input.name, onChange: (event) => {
                    if (maxLength) {
                        if (event.target.value.length <= maxLength) {
                            input.onChange(event.target.value);
                        }
                    }
                    else {
                        input.onChange(event.target.value);
                    }
                } }));
        }
        if (type === 'country') {
            field = React.createElement(country_select_1.default, { ...input, id: id, name: input.name });
        }
        if (type === 'state') {
            field = (React.createElement(state_field_1.default, { ...input, value: country ? input.value : null, id: id, className: className || '', name: input.name, country: country }));
        }
        if (type === 'phone-label') {
            field = (React.createElement("select", { ...input, id: id, className: "SelectBox-options phone-type", name: input.name },
                React.createElement("option", { value: "mobile" }, "Mobile"),
                React.createElement("option", { value: "home" }, "Home"),
                React.createElement("option", { value: "work" }, "Work"),
                React.createElement("option", { value: "other" }, "Other")));
        }
        return field;
    }
    render() {
        const { fieldGroupClass, meta: { error }, type, label, id, } = this.props;
        let fixedFieldGroupClass = fieldGroupClass;
        // this accounts for a bug in the household modal error styling
        if ((0, lodash_1.includes)(fieldGroupClass, 'Household-name') && error) {
            fixedFieldGroupClass = 'Household-name-error';
        }
        const additionalClasses = fixedFieldGroupClass ? fixedFieldGroupClass : '';
        const errorClass = error ? 'error ' : '';
        const combinedFieldClasses = type === 'phone-label' || type === 'phone'
            ? errorClass + additionalClasses
            : 'FieldGroup ' + errorClass + additionalClasses;
        const showLabel = label && type !== 'checkbox';
        return (React.createElement("div", { className: combinedFieldClasses },
            showLabel && (React.createElement("label", { className: "FieldGroup-label", htmlFor: id }, label)),
            this.renderField(),
            this.showErrors()));
    }
    showErrors() {
        const { meta: { error }, } = this.props;
        const { validDate } = this.state;
        if (!validDate) {
            return React.createElement("div", { className: "validation-error" }, "You must enter the date in the format M/D/YYYY");
        }
        else if (error || (error && !validDate)) {
            // it was: else if (error || error & !validDate)
            return error.map((error, index) => (React.createElement("div", { key: index, className: "validation-error" }, error)));
        }
    }
}
exports.default = FormFieldElement;
